import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 25,
	viewBox: "0 0 15 25",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.49999 1.24536L0.499999 23.7546C0.499999 24.6204 1.52544 25.0771 2.16896 24.4979L14.6741 13.2433C15.1155 12.846 15.1155 12.1539 14.6741 11.7567L2.16895 0.502069C1.52543 -0.0771012 0.49999 0.379593 0.49999 1.24536Z",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
